<template>
  <div>
    <van-form class="mt10" @submit="save">
      <van-field
        input-align="right"
        v-model="username"
        label="申报金额"
        placeholder="请输入金额"
        :rules="[{ required: true, message: '请填写申报金额' }]"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        :value="value"
        label="业务单元"
        placeholder="请选择"
        @click="showCollectionCompany = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="申报日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        :value="value"
        label="付款方式"
        placeholder="请选择"
        @click="showCollectionCompany = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="付款子类"
        placeholder="请选择"
        @click="showPaymentSubType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="货币"
        placeholder="请选择"
        @click="showCurrency = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="支出类别"
        placeholder="请选择"
        @click="showFundCategory = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="详细类别"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="收款单位"
        placeholder="请选择"
        @click="showPaymentAccount = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="凭证号"
        placeholder="请选择"
        @click="showDetailType = true"
      />
    </van-form>
    <van-row :gutter="10" class="mt10">
      <van-col :span="12">
        <van-button block type="info" @click="pay()">上传附件</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block type="primary" @click="submitUpdPayment()">提交</van-button>
      </van-col>
    </van-row>
    <!--收款单位弹窗-->
    <van-popup v-model="showCollectionCompany" position="bottom">
      <van-picker
        show-toolbar
        :columns="collectionCompany"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showCollectionCompany = false"
      />
    </van-popup>
    <!--付款日期-->
    <van-popup v-model="showPaymentDate" position="bottom">
      <van-datetime-picker
        type="time"
        @confirm="onShowPaymentDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--资金类别-->
    <van-popup v-model="showFundCategory" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.collectionCompany"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--付款账户-->
    <van-popup v-model="showPaymentAccount" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentAccount"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--货币-->
    <van-popup v-model="showCurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.currency"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
    <!--付款类别-->
    <van-popup v-model="showPaymentType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentType"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showPaymentType = false"
      />
    </van-popup>
    <!--付款子类别-->
    <van-popup v-model="showPaymentSubType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentSubType"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showPaymentSubType = false"
      />
    </van-popup>
    <!--详细类别-->
    <van-popup v-model="showDetailType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.detailType"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showDetailType = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import vuePickers from 'vue-pickers'

  export default {
    name: "Applying",
    components: {
      vuePickers
    },
    data() {
      return {
        showCollectionCompany: false,//收款单位弹窗
        showPaymentDate: false,//付款日期
        showFundCategory: false,//付款账户
        showPaymentAccount: false,//资金类别
        showCurrency: false,//货币
        showPaymentType: false,//付款类别
        showPaymentSubType: false,//付款子类别
        showDetailType: false,//详细类别
        popupData: {
          collectionCompany: [//收款单位
            {text: '单位1', value: '1'},
            {text: '单位2', value: '2'}
          ],
          fundCategory: [//资金类别
            {text: '类别1', value: '1'},
            {text: '类别2', value: '2'}
          ],
          paymentAccount: [//付款账户
            {text: '账户1', value: '1'},
            {text: '账户2', value: '2'}
          ],
          currency: [//货币
            {text: '货币1', value: '1'},
            {text: '货币2', value: '2'}
          ],
          paymentType: [//付款类别
            {text: '付款类别1', value: '1'},
            {text: '付款类别2', value: '2'}
          ],
          paymentSubType: [//付款子类别
            {text: '付款子类别1', value: '1'},
            {text: '付款子类别2', value: '2'}
          ],
          detailType: [//详细类别
            {text: '详细类别1', value: '1'},
            {text: '详细类别2', value: '2'}
          ],
        },

        //==============================//
        subcategory: '',
        isshow5: false,
        subcatelist: [],
        subcacon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        selectBirthDate: '',
        show: false,
        currencyList: [],
        currencyCon: {
          data1: [{
            text: '',
            value: ''
          }]
        },
        Log: '',
        isshow: false,
        columns: 1,
        customerList: ['全部', '其他'],
        GUID: '',
        Remark: '',
        Date: '',
        Amount: '',
        Currency: '',
        Business_GUID: '',
        SubBusiness_GUID: '',
        RPer: '',
        C_GUID: '',
        State: '',
        InvType: '',
        DtsInvType: '',
        RPType: '',
        DetailRPType: '',
        VoucherNo: '',
        DisAmount: '',
        Record: '',
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        isshow4: false,
        RPTypeconlist: {
          data1: [
            {
              text: '11111',
              value: '111111'
            }
          ]
        }
      }
    },

    mounted() {
      this.BirthDateSelect()
      this.getcurrency()
      this.GetCustomer()
      this.GetBankInfo();
      this.GetPayOrReceivablesType()
    },
    methods: {
      GetCustomer() {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayeeJson',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList = res.data.result
          // custormlog.style.display="block"
          this.customercon.data1 = new Array();
          for (var i = 0; i < this.customerList.length; i++) {
            this.customercon.data1.push({
              "text": this.customerList[i].Name,
              "value": this.customerList[i].Name,
              'RPercon': this.customerList[i].BP_GUID
            })
          }
        })
      },
      GetBankInfo() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetBankInfo',
          data: this.$qs.stringify({
            cGuid: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.subcatelist = res.data
          this.subcacon.data1 = new Array()
          console.log(this.subcatelist)
          for (var i = 0; i < this.subcatelist.length; i++) {
            this.subcacon.data1.push({'text': this.subcatelist[i].label, 'value': this.subcatelist[i].label})
          }

        })
      },
      GetPayOrReceivablesType() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayOrReceivablesType',
          data: this.$qs.stringify({
            cGuid: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.RPTypeconcon = res.data
          this.RPTypeconlist.data1 = new Array();
          console.log(res.data)
          for (var i = 0; i < this.RPTypeconcon.length; i++) {
            this.RPTypeconlist.data1.push({
              "text": this.RPTypeconcon[i].label,
              'value': this.RPTypeconcon[i].label,
              'payid': this.RPTypeconcon[i].value
            })
            console.log(this.RPTypeconcon[i])
          }
          console.log(res.data)
        })
      },
      BirthDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      submitUpdPayment() {
        let a = JSON.stringify({
          GUID: '58932e79-0a06-4a2e-89e6-6379fdc7514e',
          Remark: '',
          Date: this.selectBirthDate,
          Amount: this.Amount,
          Currency: this.Currency,
          Business_GUID: '',
          SubBusiness_GUID: '',
          RPer: sessionStorage.getItem('RPercon'),
          C_GUID: sessionStorage.getItem('companyId'),
          State: '',
          InvType: '预付供应商账款',
          DtsInvType: '',
          RPType: this.RPType,
          DetailRPType: '',
          VoucherNo: '',
          DisAmount: this.Amount,
          Record: '',
        })
        this.$axios.post('/fmsapi/PaymentDeclareCostSpending/UpdPaymentDeclareCostSpending', a, {
          headers: {
            'Content-Type': 'application/json;'
          }
        }).then(res => {
          console.log(res.data)
          this.$router.push({path: "/home"})
        })
      },
      getcurrency() {
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {
          this.currencyList = res.data.result
          this.currencyCon.data1 = new Array();
          for (var i = 0; i < this.currencyList.length; i++) {
            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})
          }
        })
      },
      subcatecon(val) {
        var sub = document.getElementById('sub')
        this.isshow5 = false
        sub.value = val.select1.value
        this.subcategory = sub.value
      },
      close5() {
        this.isshow5 = false
      },
      tosub(val) {
        if (this.RPType === '银行存款') {
          this.isshow5 = true
        } else {
          this.isshow5 = false
        }
      },
      RPTypecon(val) {
        var btn4 = document.getElementById('rptype')
        console.log(val.select1.value)
        sessionStorage.setItem('payid', val.select1.payid)
        this.isshow4 = false
        btn4.value = val.select1.value
        this.RPType = btn4.value
      },
      close4() {
        console.log(123)
        this.isshow4 = false
      },
      toRPType(val) {
        this.isshow4 = true
      },
      close() {
        console.log(123)
        this.show = false
      },
      close1() {
        console.log(123)
        this.isshow = false
      },
      toCus(val) {
        this.isshow = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      currycon(val) {
        var btn = document.getElementById('btncon')
        this.show = false
        btn.value = val.select1.value
        this.Currency = btn.value
      },
      concus(val) {
        var btn2 = document.getElementById('icon2')
        console.log(val.select1.value)
        sessionStorage.setItem('RPercon', val.select1.RPercon)
        this.isshow = false
        btn2.value = val.select1.value
        this.Log = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      toCurry(val) {
        this.show = true
      },
      pay() {
        this.$router.push({path: '/pay'})
      },
      findpay() {
        this.$router.push({path: '/findpay'})
      },
      findquery() {
        this.$router.push({path: '/findquery'})
      },
      back() {
        this.$router.push('/home')
      },
    }
  }
</script>
